import {useFormSummaryContent} from '@/content/formSummary'
import {useTranslation} from '@/i18n'
import {getRenewalCategoryFeeTiers} from '@/utils/pricing/renewal/calculations'

type TrademarkRenewalCategoryFeeRow = {
  title: string
  price: number
  note?: string
}

export const useRenewalCategoryFeeRows = (
  categoryFees: Record<number, number> | false | undefined,
): TrademarkRenewalCategoryFeeRow[] => {
  const {t} = useTranslation()
  const {secondClassTitle, secondAndThirdClassTitle, eachAdditionalClassTitle, freeTitle} =
    useFormSummaryContent()

  const [firstFeeTier, secondFeeTier] = categoryFees ? getRenewalCategoryFeeTiers(categoryFees) : []

  if (!firstFeeTier) {
    return []
  }

  const rows: TrademarkRenewalCategoryFeeRow[] = [
    {
      title: !secondFeeTier
        ? t(eachAdditionalClassTitle)
        : secondFeeTier.point - firstFeeTier.point > 1
        ? t(secondAndThirdClassTitle)
        : t(secondClassTitle),
      price: firstFeeTier.price,
      note: firstFeeTier.price === 0 ? t(freeTitle) : undefined,
    },
  ]

  if (secondFeeTier) {
    rows.push({title: t(eachAdditionalClassTitle), price: secondFeeTier.price})
  }

  return rows
}
